<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M3 5H7V9H3V5Z" fill="currentColor" />
    <path d="M3 11H7V15H3V11Z" fill="currentColor" />
    <path
      d="M9 7C9 6.58579 9.33579 6.25 9.75 6.25H16.25C16.6642 6.25 17 6.58579 17 7C17 7.41421 16.6642 7.75 16.25 7.75H9.75C9.33579 7.75 9 7.41421 9 7Z"
      fill="currentColor"
    />
    <path
      d="M9 13C9 12.5858 9.33579 12.25 9.75 12.25H16.25C16.6642 12.25 17 12.5858 17 13C17 13.4142 16.6642 13.75 16.25 13.75H9.75C9.33579 13.75 9 13.4142 9 13Z"
      fill="currentColor"
    />
  </svg>
</template>
